export default __webpack_public_path__ + "e20e6f8467524cdc8c55ee278a4f02c5.svg";